var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDrop = function SvgIconDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.921 30.203a.77.77 0 1 0-1.466.478 8.9 8.9 0 0 0 3.22 4.445 8.85 8.85 0 0 0 5.21 1.698.772.772 0 0 0 0-1.546 7.3 7.3 0 0 1-4.304-1.403 7.34 7.34 0 0 1-2.66-3.672"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m23.5 9.083-.532.51-.003.002-.007.007-.025.024-.094.092q-.124.121-.35.35a55.674 55.674 0 0 0-5.004 5.875c-2.71 3.684-5.547 8.62-5.547 13.244 0 5.985 5.238 10.73 11.562 10.73s11.563-4.745 11.563-10.73c0-4.625-2.838-9.56-5.547-13.244a56 56 0 0 0-5.004-5.874 33 33 0 0 0-.445-.443l-.025-.024-.007-.007zm-1.119 3.341c.453-.493.836-.893 1.119-1.182a54.137 54.137 0 0 1 4.775 5.62c2.688 3.654 5.246 8.237 5.246 12.325 0 5.012-4.425 9.183-10.021 9.183s-10.02-4.17-10.02-9.183c0-4.088 2.557-8.67 5.245-12.326a54 54 0 0 1 3.656-4.437",
    clipRule: "evenodd"
  })));
};
export default SvgIconDrop;